// src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import SeoManager from './components/SeoManager';

// Pages
import Home from './pages/Home';
import ProductDetailPage from './pages/ProductDetailPage';
import CategoryPage from './pages/CategoryPage';
import CartPage from './pages/CartPage';
import ProfilePage from './pages/ProfilePage';
import BuyerOrdersPage from './pages/BuyerOrdersPage';
import OrderDetailPage from './pages/OrderDetailPage';
import BecomeSellerPage from './pages/BecomeSellerPage';
import AboutUsPage from './pages/AboutUsPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import YouthPage from './pages/YouthPage';
import DisclaimerPage from './pages/DisclaimerPage';
import EmailPage from './pages/EmailPage';
import SellerInquiryPage from './pages/SellerInquiryPage';
import SearchResultsPage from './pages/SearchResultsPage';

// Seller Dashboard
import SellerDashboardLayout from './pages/seller/SellerDashboardLayout';
import OverviewPage from './pages/seller/OverviewPage';
import ProductManagementPage from './pages/seller/ProductManagementPage';
import OrderManagementPage from './pages/seller/OrderManagementPage';
import ShippingPage from './pages/seller/ShippingPage';
import FinancialsPage from './pages/seller/FinancialsPage';
import SellerProfilePage from './pages/seller/SellerProfilePage';
import AnalyticsPage from './pages/seller/AnalyticsPage';
import EditProductPage from './pages/seller/EditProductPage';
import SellerMessagesPage from './pages/seller/SellerMessagesPage';
import SellerReviewsPage from './pages/seller/SellerReviewsPage';
import SellerChatPage from './pages/seller/SellerChatPage';

// Components
import Header from './components/Header';
import Footer from './components/Footer';
import AuthModal from './components/AuthModal';
import ProductUploadForm from './components/ProductUploadForm';

const AppContent = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <SeoManager /> {/* ✅ 전역 SEO 관리자 */}
      <main className="pt-16">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/product/:id" element={<ProductDetailPage />} />
          
          {/* 제품 목록 */}
          <Route path="/products" element={<CategoryPage viewMode="all-products" />} />
          <Route path="/latest" element={<CategoryPage viewMode="latest-products" />} />
          <Route path="/popular" element={<CategoryPage viewMode="popular-products" />} />
          <Route path="/recommended" element={<CategoryPage viewMode="recommended-products" />} />
          
          {/* AI 검색 결과 */}
          <Route path="/search" element={<SearchResultsPage />} />
          
          {/* 카테고리 */}
          <Route path="/category/:main" element={<CategoryPage />} />
          <Route path="/subcategory/:main/:sub" element={<CategoryPage />} />

          {/* 계정 및 장바구니 */}
          <Route path="/cart" element={<CartPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/buyer-orders" element={<BuyerOrdersPage />} />
          <Route path="/order/:id" element={<OrderDetailPage />} />

          {/* 셀러 */}
          <Route path="/upload" element={<ProductUploadForm />} />
          <Route path="/become-seller" element={<BecomeSellerPage />} />

          {/* 셀러 대시보드 */}
          <Route path="/seller/*" element={<SellerDashboardLayout />}>
            <Route index element={<OverviewPage />} />
            <Route path="products" element={<ProductManagementPage />} />
            <Route path="edit-product/:id" element={<EditProductPage />} /> {/* ✅ 추가 */}
            <Route path="orders" element={<OrderManagementPage />} />
            <Route path="shipping" element={<ShippingPage />} />
            <Route path="financials" element={<FinancialsPage />} />
            <Route path="profile" element={<SellerProfilePage />} />
            <Route path="analytics" element={<AnalyticsPage />} />
            <Route path="reviews" element={<SellerReviewsPage />} />
            <Route path="messages" element={<SellerMessagesPage />} />
            <Route path="SellerChatPage/:chatId" element={<SellerChatPage />} />

          </Route>

          {/* 기타 정적 페이지 */}
          <Route path="/about-us" element={<AboutUsPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/youth" element={<YouthPage />} />
          <Route path="/disclaimer" element={<DisclaimerPage />} />
          <Route path="/email" element={<EmailPage />} />
          <Route path="/seller-inquiry" element={<SellerInquiryPage />} />

          {/* 404 */}
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
      <AuthModal />
    </div>
  );
};

const App = () => {
  return (
    <AppProvider>
      <Router>
        <AppContent />
      </Router>
    </AppProvider>
  );
};

export default App;
